import { UID } from 'shared/api/query/constants';

export const directPropGoalSelfFn = (isFilterMode = false) => (scope) => {
  if (scope.isEmpty === true) {
    return {
      filterTrees: [{ func: { name: UID, uid: [0] } }],
      varBlocks: [],
    };
  }

  const relations = scope.relations || [];
  if (relations.length === 0 && isFilterMode) {
    return { filterTrees: [], varBlocks: [] };
  }

  const filterTree = {
    func: {
      name: UID,
      uid: relations.map((r) => r.uid),
    },
  };

  return { filterTrees: [filterTree], varBlocks: [] };
};
